var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMouseWheel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 65,
    viewBox: "0 0 40 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mouse_wheel_svg__clip0_248_529)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 0C8.943 0 0 9.029 0 20.191V44.81C0 55.97 8.943 65 20 65s20-9.029 20-20.191V20.19C40 9.03 31.057 0 20 0zm0 62.215c-9.575 0-17.241-7.74-17.241-17.406V29.834H37.24V44.81c0 9.666-7.666 17.406-17.241 17.406z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.38 2.85c8.918.705 15.861 8.146 15.861 17.341V27.1H21.304v-.802a5.584 5.584 0 004.213-5.41v-8.354c0-2.58-1.768-4.75-4.138-5.374v-4.31z",
    fill: "#1E7391"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.759 12.533v8.354c0 1.567-1.207 2.785-2.759 2.785-1.552 0-2.759-1.218-2.759-2.785v-8.354c0-1.567 1.207-2.785 2.759-2.785 1.552 0 2.759 1.218 2.759 2.785z",
    fill: "#47F5D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.62 2.85v4.308a5.57 5.57 0 00-4.137 5.373v8.355a5.585 5.585 0 004.112 5.385v.827H2.759V20.19c0-9.194 6.943-16.634 15.862-17.34z",
    fill: "#1E7391"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "mouse_wheel_svg__clip0_248_529"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v65H0z"
  })))));
}
export default SvgMouseWheel;